import { Injectable } from '@angular/core';
var LyCheckboxService = /** @class */ (function () {
    function LyCheckboxService() {
    }
    LyCheckboxService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LyCheckboxService.ctorParameters = function () { return []; };
    return LyCheckboxService;
}());
export { LyCheckboxService };
//# sourceMappingURL=ly-checkbox.service.js.map